// src/components/InboxContent.tsx
import React, { useMemo } from "react";
import { useNotificationOutlets } from "../hooks/internal/useNotificationOutlets.js";
import { Mounter } from "./Mounter.js";
import { OutletScope } from "./OutletScope.js";
import { jsx } from "react/jsx-runtime";
var InboxContentMount = (props) => {
  const { onNotificationClick, onPrimaryActionClick, onSecondaryActionClick, initialPage, hideNav } = props;
  const outlets = useNotificationOutlets(props);
  const mountProps = useMemo(
    () => ({ ...outlets, onNotificationClick, onPrimaryActionClick, onSecondaryActionClick, initialPage, hideNav }),
    [outlets, onNotificationClick, onPrimaryActionClick, onSecondaryActionClick, initialPage, hideNav]
  );
  return /* @__PURE__ */ jsx(Mounter, { name: "InboxContent", props: mountProps });
};
var InboxContent = React.memo((props) => /* @__PURE__ */ jsx(OutletScope, { children: /* @__PURE__ */ jsx(InboxContentMount, { ...props }) }));
InboxContent.displayName = "InboxContent";
export {
  InboxContent
};
//# sourceMappingURL=InboxContent.js.map